import React, { useState } from "react";
import { Container } from "..";
import { Accordion } from "../../../../../app/components";
import CustomCell from "../../../../../app/components/custom.tables.components/custom.cell";
import CustomRow from "../../../../../app/components/custom.tables.components/custom.row";
import EditNotesInput from "../edit.notes.input";
import CustomTooltip from "../../../../../app/components/tooltip/custom.tooltip";
import { useRestoreTableVisibility } from "../../hooks/useRestoreTableVisibility";
import { DATA_TABLE_NAME } from "../../constants";
import { toParticipantUiText } from "../../../../../app/utils/participantTerminology";

export default function IMVTable({ data, readOnly }) {
  const [editState, setEditState] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);

  useRestoreTableVisibility('IMVTable', setIsExpanded);

  const renderTable = () => {
    return data.map((d, idx) => {
      return (
        <CustomRow key={idx}>
          <CustomCell
            variant="header"
            justify="flex-end"
            width="30%"
            style={{
              borderBottom: "none",
            }}
            textAlign="right"
          >
            {toParticipantUiText(d.rowLabel)}
          </CustomCell>
          <CustomCell width="10%">
            <CustomTooltip title={d.cellValue1?.toString() || ''}>
              <div>{d.cellValue1}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width="10%">
            <CustomTooltip title={d.cellValue2?.toString() || ''}>
              <div>{d.cellValue2}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell width="10%">
            <CustomTooltip title={d.cellValue3?.toString() || ''}>
              <div>{d.cellValue3}</div>
            </CustomTooltip>
          </CustomCell>
          <CustomCell
            style={{
              position: "relative",
            }}
            textAlign="left"
            justify="flex-start"
            width="40%"
          >
            <EditNotesInput
              d={d}
              editState={editState}
              setEditState={setEditState}
              readOnly={readOnly}
            />
          </CustomCell>
        </CustomRow>
      );
    });
  };

  return (
    <Accordion
      scrollIntoView={true}
      width={"100%"}
      summary={"IMV Budgeting"}
      defaultExpanded={isExpanded}
      onChange={(e, expanded) => setIsExpanded(expanded)}
      data-table-name={DATA_TABLE_NAME.IMV_TABLE}
    >
      <Container 
        onClick={(e) => e.stopPropagation()} 
        data-table-name={DATA_TABLE_NAME.IMV_TABLE}
        data-table-container="true"
      >
        {renderTable()}
      </Container>
    </Accordion>
  );
}
